import {Action} from "redux-actions";
import {
	FINANCE_PRODUCT_CREATED,
	FINANCE_PRODUCT_UPDATED,
	FINANCE_PRODUCTS_FETCHED,
	FINANCE_PRODUCTS_SORT_ORDER_UPDATED
} from "./actionType";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import FinanceProduct from "../../../model/financeProduct/FinanceProduct";

/**
 * Finance products fetch successful action.
 * @return {Action<FINANCE_PRODUCTS_FETCHED>}
 * @param products
 */
export function financeProductsFetched(products: FinanceProduct[]): Action<FINANCE_PRODUCTS_FETCHED> {
	return {type: FINANCE_PRODUCTS_FETCHED, payload: {products}}
}

/**
 * Update finance products sort order successful action.
 * @return {Action<FINANCE_PRODUCTS_SORT_ORDER_UPDATED>}
 * @param products
 */
function financeProductsSortOrderUpdated(products: Array<FinanceProduct>): Action<FINANCE_PRODUCTS_SORT_ORDER_UPDATED> {
	return {type: FINANCE_PRODUCTS_SORT_ORDER_UPDATED, payload: {products}};
}

/**
 * Finance product create successful action.
 * @return {Action<FINANCE_PRODUCT_CREATED>}
 * @param product
 */
export function financeProductCreated(product: FinanceProduct): Action<FINANCE_PRODUCT_CREATED> {
	return {type: FINANCE_PRODUCT_CREATED, payload: {product}}
}

/**
 * Finance product successful action.
 * @return {Action<FINANCE_PRODUCT_UPDATED>}
 * @param product
 */
export function financeProductUpdated(product: FinanceProduct): Action<FINANCE_PRODUCT_UPDATED> {
	return {type: FINANCE_PRODUCT_UPDATED, payload: {product}}
}

/**
 * Fetch products action.
 */
export function fetchFinanceProducts(onSuccess: OnSuccessData<FinanceProduct[]>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.financeProductApi.fetchFinanceProducts().then((products: FinanceProduct[]) => {
			dispatch(financeProductsFetched(products));
			onSuccess(products);
		}).catch(onFailure);
	};
}

/**
 * Update finance product sort order.
 * @param products
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateFinanceProductsSortOrder(products: FinanceProduct[],
	onSuccess: OnSuccess,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.financeProductApi.updateFinanceProductsSortOrder(products.map(c => c.id)).then(() => {
			dispatch(financeProductsSortOrderUpdated(products));
			dispatch(onSuccess);
		}).catch(onFailure);
	};
}

/**
 * Create finance product.
 * @param financeProduct
 * @param onSuccess
 * @param onFailure
 */
export function createFinanceProduct(financeProduct: FinanceProduct, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.financeProductApi.createFinanceProduct(financeProduct.toJson()).then(product => {
			dispatch(financeProductCreated(product));
			onSuccess();
		}).catch(onFailure);
	}
}

/**
 * Update finance product.
 * @param fpId
 * @param financeProduct
 * @param {OnSuccess} onSuccess Success callback.
 * @param {OnFailure} onFailure Failure callback.
 */
export function editFinanceProduct(fpId: string, financeProduct: FinanceProduct, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.financeProductApi.updateFinanceProduct(fpId, financeProduct).then((product) => {
			dispatch(financeProductUpdated(product));
			onSuccess();
		}).catch(onFailure);
	}
}
